import { render, staticRenderFns } from "./SidebarHomeRtl.vue?vue&type=template&id=04ea715f"
import script from "./SidebarHomeRtl.vue?vue&type=script&lang=js"
export * from "./SidebarHomeRtl.vue?vue&type=script&lang=js"
import style0 from "./SidebarHomeRtl.vue?vue&type=style&index=0&id=04ea715f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports